import React, { useEffect, useRef } from 'react'
import { Link, useLocation } from 'react-router-dom'
import SideNavItem from '@/component/layout/SideNav/SideNavItem.tsx'
import { useNavItems } from '@/component/layout/SideNav/navItems.ts'
import { useAccountProfile } from '@/component/layout/TopNav/accountProfile.ts'
import { useIsDrawerWidth, useSideNavStore } from '@/store/SideNavStore.ts'

export const SIDE_NAV_DRAWER_ID = 'app-side-nav-drawer'

interface IProps {
    returnFocusRef: React.RefObject<HTMLElement>
}

/** 1023px 이하: 상단바 ☰ 로 여는 서랍 */
const SideNavDrawer: React.FC<IProps> = ({ returnFocusRef }) => {
    const navItems = useNavItems()
    const { name, email, initial } = useAccountProfile()
    const isOpen = useSideNavStore((state) => state.isDrawerOpen)
    const closeDrawer = useSideNavStore((state) => state.closeDrawer)
    const isDrawerWidth = useIsDrawerWidth()
    const location = useLocation()
    const panelRef = useRef<HTMLElement>(null)

    useEffect(() => {
        closeDrawer()
    }, [location.pathname, location.search, isDrawerWidth, closeDrawer])

    useEffect(() => {
        if (!isOpen) return
        panelRef.current?.querySelector<HTMLElement>('a[href]')?.focus()
        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key !== 'Escape') return
            closeDrawer()
            returnFocusRef.current?.focus()
        }
        window.addEventListener('keydown', onKeyDown)
        return () => window.removeEventListener('keydown', onKeyDown)
    }, [isOpen, closeDrawer, returnFocusRef])

    if (!isOpen || !isDrawerWidth) return null

    return (
        <div className={'app-drawer-layer z-modal'}>
            <button
                type={'button'}
                tabIndex={-1}
                aria-label={'Close navigation menu'}
                className={'app-drawer-layer__backdrop'}
                onClick={() => {
                    closeDrawer()
                    returnFocusRef.current?.focus()
                }}
            />
            <aside id={SIDE_NAV_DRAWER_ID} ref={panelRef} className={'app-side-nav app-drawer'}>
                <nav
                    className={'app-side-nav__menu'}
                    aria-label={'Main navigation'}
                    onClick={(e) => {
                        if ((e.target as HTMLElement).closest('a')) closeDrawer()
                    }}
                >
                    {navItems.map(item => <SideNavItem key={item.id} {...item} />)}
                </nav>
                <Link to={'/account'} className={'app-drawer__account'}>
                    <span className={'top-nav__avatar'}>{initial}</span>
                    <span className={'app-drawer__account-copy'}>
                        <strong>{name}</strong>
                        {email && <small>{email}</small>}
                    </span>
                </Link>
            </aside>
        </div>
    )
}

export default SideNavDrawer
